export default "__VITE_ASSET__Cgx6MXbA__"